// web-frontend/src/main.jsx
// 🔥 [2026-06-27 보안] 운영 빌드에서는 console.log/info/debug 를 전역 비활성화(개인정보·토큰 콘솔 노출 차단).
//   다수의 console.log('...', response.data) 가 이메일·전화·임시비밀번호 등을 콘솔에 덤프하던 문제 차단. warn/error 는 유지.
if (import.meta.env.PROD) {
  const noop = () => {};
  // eslint-disable-next-line no-console
  console.log = noop; console.info = noop; console.debug = noop;
}
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';
import './styles/buttons.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);